var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03Entertaiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5 0.000610352C115.644 0.000610352 149 33.3546 149 74.5005C149 115.645 115.644 149.001 74.5 149.001C33.3552 149.001 0.00109863 115.645 0.00109863 74.5005C0.00109863 33.3546 33.3552 0.000610352 74.5 0.000610352Z",
    fill: "url(#paint0_linear_1_10)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.197 71.4078C119.024 70.5298 118.429 68.2739 116.478 64.9301C111.419 56.2566 100.894 41.1429 94.519 38.3519C86.0706 34.6523 75.5631 44.5916 78.8149 49.5325C82.0667 54.4733 86.7388 47.0798 92.0804 51.0293C95.3723 53.462 98.6595 60.7896 100.697 66.0569H51.1702C53.2092 60.7896 56.4964 53.462 59.7871 51.0293C65.1299 47.0798 69.802 54.4733 73.0526 49.5325C76.3045 44.5916 65.797 34.6523 57.3486 38.3519C50.9745 41.1429 40.4494 56.2566 35.3906 64.9301C33.9634 67.3781 33.2609 69.2427 32.9191 70.4119C32.4996 71.3395 32.2637 72.3673 32.2637 73.4492V96.3075C32.2637 100.383 35.5805 103.7 39.6573 103.7L60.8196 103.696C61.7107 103.696 62.5651 103.421 63.2888 102.897L76.1382 93.6132L88.3901 102.852C89.1174 103.401 90.0202 103.703 90.9301 103.703L112.094 103.705C116.169 103.705 119.486 100.386 119.486 96.3075V73.4492C119.486 72.7408 119.383 72.0573 119.197 71.4078ZM111.049 95.268L92.3433 95.2669L78.7313 85.0022C78.0052 84.4541 77.1024 84.1524 76.1924 84.1524C75.3002 84.1524 74.4458 84.4282 73.7221 84.9514L59.4535 95.2609L40.6992 95.2633V74.4923H111.049V95.268Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6968 77.908C65.685 77.908 65.6756 77.908 65.6661 77.908L43.014 77.9186V92.6609L57.7787 92.6585L69.9528 83.8625C69.5379 78.5233 66.8896 77.908 65.6968 77.908Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0517 77.9752C84.8601 77.9752 82.2118 78.5905 81.7969 83.9297L93.971 92.7257L108.734 92.7281V77.9858C108.734 77.9858 86.0635 77.9752 86.0517 77.9752ZM106.726 90.7186L94.6204 90.7173L83.9349 82.995C84.16 81.6878 84.6939 80.0649 85.9574 79.9871L106.726 79.9953V90.7186Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_10",
    x1: 127.18,
    y1: 127.18,
    x2: 21.8212,
    y2: 21.8217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BA334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6E321"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Entertaiment);
export default __webpack_public_path__ + "static/media/03_entertaiment.aecb41540f8b13fc5f2af121fff12ff7.svg";
export { ForwardRef as ReactComponent };